var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 23.125C4.375 18.3104 4.375 6.875 4.375 6.875C4.375 4.80393 6.05393 3.125 8.125 3.125H21.875V19.375C21.875 19.375 11.3954 19.375 8.125 19.375C6.0625 19.375 4.375 21.0526 4.375 23.125Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 19.375C21.875 19.375 8.84606 19.375 8.125 19.375C6.05393 19.375 4.375 21.0539 4.375 23.125C4.375 25.1961 6.05393 26.875 8.125 26.875C9.50569 26.875 16.1724 26.875 25.625 26.875V4.375",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 23.125H21.25",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBooks);
export default __webpack_public_path__ + "static/media/icon-books.11e6eea6716c2ef275c03433b6c6ca20.svg";
export { ForwardRef as ReactComponent };